import request from '../../utils/request';
import { stringify } from 'qs';
import { getSiteIp } from '../../utils/index';

export async function getCategory(params) {
  return request(`/api/tscloud-res/res-category/detail?${stringify(params)}`);
}

export async function list(params) {
  return request(`/api/tscloud-res/res/page?${stringify(params)}`);
}

export async function getPlayUrl(params) {
  const { fileInfoId, ...payload } = { ...params, siteIp: getSiteIp() };
  return request(`/api/blade-mbs/file-info/play-url/${fileInfoId}?${stringify({ ...payload })}`);
}

export async function info(params) {
  return request(`/api/tscloud-res/res/detailInfo?${stringify(params)}`);
}

export async function getViewUrl(params) {
  const { fileInfoId, ...payload } = { ...params, siteIp: getSiteIp() };
  return request(`/api/blade-mbs/file-info/view-url/${fileInfoId}?${stringify({ ...payload })}`);
}

export async function getDownloadUrl(params) {
  const { fileInfoId, ...payload } = { ...params, siteIp: getSiteIp() };
  return request(
    `/api/blade-mbs/file-info/download-url/${fileInfoId}?${stringify({ ...payload })}`,
  );
}

export async function getResModelList(params) {
  return request(`/api/tscloud-res/res-model/list?${stringify(params)}`);
}

export async function getResAttrModelList(params) {
  return request(`/api/tscloud-res/app-attr-model/list?${stringify(params)}`);
}
